import "dayjs/locale/nl";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.locale("nl");
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
export default dayjs;
